import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toast_init: Subject<any> = new Subject();
  constructor() { }
  
  alert(msg,autohide){
    //Common.log("call Show_palyer dd")
   this.toast_init.next({ show:true,msg:msg,autohide:autohide,toast_type:1});
  }

  info(msg,show_close,autohide){
    //Common.log("call Show_palyer dd")
   this.toast_init.next({ show:true,msg:msg,autohide:autohide,toast_type:2,show_close:show_close});
  }

  success(msg,show_close,autohide){
    //Common.log("call Show_palyer dd")
   this.toast_init.next({ show:true,msg:msg,autohide:autohide,toast_type:3,show_close:show_close});
  }

  // Show(msg,autohide){
  //   //Common.log("call Show_palyer dd")
  //  this.toast_init.next({ show:true,msg:msg,autohide:autohide});
  // }

  // Hide(){
  //   this.toast_init.next({ show:false});
  // }

}
